import { FormControl, MenuItem, TextField, Typography, Box } from "@mui/material";
import { useSelector } from "react-redux";
import { store } from "../store";
import { useTranslation } from "react-i18next";
import { useMediaQuery, useTheme } from "@mui/material";
import { Button } from "@mui/material";
import { Settings, Search } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

export default function SelectEstablishment() {
  const establishments = useSelector((state) => state.establishments);
  const residences = useSelector((state) => state.residences);
  const selectedEstablishment = useSelector(
    (state) => state.selectedEstablishment
  );

  const { t } = useTranslation("common");

  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const hasSingleEstablishment = establishments.length === 1;

  // Auto-select the single establishment if there's only one
  useEffect(() => {
    if (hasSingleEstablishment && selectedEstablishment !== establishments[0].id) {
      store.dispatch({
        type: "selectedEstablishment/update",
        payload: establishments[0].id,
      });
      localStorage.setItem("selectedEstablishment", establishments[0].id);
    }
  }, [hasSingleEstablishment, establishments, selectedEstablishment]);

  const handleChange = (event) => {
    store.dispatch({
      type: "selectedEstablishment/update",
      payload: event.target.value,
    });
    localStorage.setItem("selectedEstablishment", event.target.value);
  };

  return (
    <div style={{ display: "flex", gap: "16px", width: "100%" }}>
      <div style={{ flex: isMobile ? "7" : "5" }}>
        {hasSingleEstablishment ? (
          // Single establishment: display name only (no dropdown)
          <Box
            sx={{
              border: "1px solid #26A69A",
              borderRadius: "4px",
              padding: "16.5px 14px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Typography
              sx={{
                color: "white",
                fontSize: "1rem",
              }}
            >
              {establishments[0].is_zone
                ? `${establishments[0].name} ${establishments[0].zone_name}`
                : establishments[0].name}
            </Typography>
          </Box>
        ) : (
          // Multiple establishments: show dropdown with "All" option
          <FormControl fullWidth>
            <TextField
              select
              label={t("common.establishment")}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#26A69A",
                  },
                  "&:hover fieldset": {
                    borderColor: "#26A69A",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#26A69A",
                  }
                },
                "& .MuiInputLabel-root": {
                  color: "#26A69A",
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "#26A69A",
                }
              }}
              onChange={handleChange}
              value={selectedEstablishment}
            >
              <MenuItem
                key="0"
                value="0"
                sx={{
                  "&.Mui-selected": {
                    backgroundColor: "#26A69A",
                    color: "white",
                    "&:hover": {
                      backgroundColor: "#00897B",
                    }
                  },
                  "&:hover": {
                    backgroundColor: "rgba(38, 166, 154, 0.1)",
                  }
                }}
              >
                {t("common.all")}
              </MenuItem>
              {establishments.map((option) => (
                <MenuItem
                  key={option.id}
                  value={option.id}
                  sx={{
                    "&.Mui-selected": {
                      backgroundColor: "#26A69A",
                      color: "white",
                      "&:hover": {
                        backgroundColor: "#00897B",
                      }
                    },
                    "&:hover": {
                      backgroundColor: "rgba(38, 166, 154, 0.1)",
                    }
                  }}
                >
                  {option.is_zone
                    ? `${option.name} ${option.zone_name} (${residences.filter(r => r.establishment_id === option.id).length})`
                    : `${option.name} (${residences.filter(r => r.establishment_id === option.id).length})`}
                </MenuItem>
              ))}
            </TextField>
          </FormControl>
        )}
      </div>
      <div style={{ display: "flex", gap: "8px", flex: "1" }}>
        <Button
          variant="contained"
          size="small"
          color="success"
          onClick={() => {
            navigate("/establishments/" + selectedEstablishment);
          }}
          sx={{ 
            height: "100%", 
            minWidth: "50px", 
            backgroundColor: "#26A69A", 
            "&:hover": { 
              backgroundColor: "#00897B" 
            } 
          }}
        >
          <Settings />
        </Button>
        <Button
          variant="contained"
          size="small"
          color="success"
          onClick={() => {
            navigate("/residences");
          }}
          sx={{ 
            height: "100%", 
            minWidth: "50px", 
            backgroundColor: "#26A69A", 
            "&:hover": { 
              backgroundColor: "#00897B" 
            } 
          }}
        >
          <Search />
        </Button>
      </div>
    </div>
  );
}
